import { useContext } from 'react';
import { KlartextEventConfigContext } from '../providers/klartextEventConfig';
import { ImageKpiPoint } from '@common/types/kpiTypes';
import { FinalStatementImageKpiPoint } from '@configTypes/kpiImage';

export const SummaryImageView = ({ imageKpiPoint }: { imageKpiPoint: FinalStatementImageKpiPoint }) => {
  const speechConfig = useContext(KlartextEventConfigContext);
  return (
    <div className="bg-green mt-5 rounded-lg p-2">
      <h1 className="font-normal py-2 text-black">{`An AI image based on the closing statement of ${imageKpiPoint.speaker}`}</h1>
      <img
        src={imageKpiPoint.value}
        alt={imageKpiPoint.altText ?? 'summary image'}
        className="h-auto w-[50rem] max-w-[90vw]"
      />
      <h1 className="font-normal py-8 text-black">Closing Statement of {imageKpiPoint.speaker}:</h1>
      <p className="text-black">{`"${imageKpiPoint.statement}"`}</p>
    </div>
  );
};
